<div class="errorbox">
  {{error.errorMessage}}
  <span *ngIf="isDebug()" class="debug-msg"> ({{error.errorCode}})</span>
</div>
